import Vue from "vue";
import VueRouter from "vue-router";
import RouterView from "./components/RouterView.vue";
import i18n from "./plugins/i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:lang/",
    component: RouterView,
    beforeEnter(to, from, next) {
      const lang = to.params.lang;

      if (["en", "ru", "zh"].includes(lang)) {
        if (i18n.locale !== lang) i18n.locale = lang;
      } else {
        next(`/${i18n.locale}/${lang}`);
      }

      return next();
    },
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/pages/Home.vue")
      },
      {
        path: "checkout",
        name: "checkout",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "@/pages/Checkout.vue")
      },
      {
        path: "delivery_widget",
        name: "delivery_widget",
        component: () => import("@/pages/delivery_widget.md")
      },
      {
        path: "delivery_widget/:site(.*)",
        name: "delivery_widget_fitting",
        component: () => import("@/pages/WidgetFitting.vue")
      },
      {
        path: "shipping",
        name: "shipping",
        component: () => import("./pages/Shipping.vue")
      },
      {
        path: "tracking",
        name: "tracking",
        component: () => import("./pages/Tracking.vue")
      },
      {
        path: "demo_request",
        name: "demo_request",
        component: () => import("./pages/DemoRequest.vue")
      },
      {
        path: "parcels",
        name: "parcels",
        component: () => import("@/pages/Parcels.vue")
      },
      {
        path: "fulfillment",
        name: "fulfillment",
        component: () => import("@/pages/Fulfillment.vue")
      },
      {
        path: "*",
        name: "404",
        component: () => import("@/pages/404.vue")
      }
    ]
  },
  {
    path: "/",
    redirect() {
      return i18n.locale + "/";
    }
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/pages/404.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior: function(to) {
    if (to.hash) {
      return { selector: to.hash };
    }
  },
  base: process.env.BASE_URL,
  routes
});

export default router;
